module.exports = __webpack_public_path__ + "img/Inlinepad-规则.686a24a9.svg";